<template>
  <div class="credit-card-form">
    <div v-if="error" class="form-group">
      <div class="alert alert-danger">{{ error }}.</div>
    </div>
    <form id="pay" @submit.prevent>
      <div class="form-group">
        <label for="creditCardInstallments">Forma de pagamento *</label>
        <select id="creditCardInstallments" class="form-input" v-model="installments" :class="{ 'invalid': validation.installments }" @blur="bluredField('installments')" @focus="focusedField('installments')">
          <option value="">Escolha a forma de pagamento</option>
          <option v-for="i in maxInstallments" :key="'inst' + i" :value="i">{{ i }}x de {{ total['creditCard' + i] / i | price }} ({{ total['creditCard' + i] | price }})</option>
        </select>
        <p>{{ validation.installments }}</p>
      </div>
      <div class="form-group">
        <label for="creditCardNumber">Número do Cartão *</label> {{ paymentMethodId }}
        <input data-checkout="cardNumber" id="creditCardNumber" class="form-input" v-model="number" type="tel" v-mask="creditCardMask" placeholder="0000 0000 0000 0000" :class="{ 'invalid': validation.number }" @blur="bluredField('number')" @focus="focusedField('number')">
        <p>{{ validation.number }}</p>
        <div class="form-input-append" :class="{ 'visible': (paymentMethodId && number.length >= 6) }">{{ paymentMethodId }}</div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label for="creditCardDueDate">Validade *</label>
            <input id="creditCardDueDate" class="form-input" v-model="dueDate" type="tel" v-mask="'##/##'" placeholder="MM/AA" :class="{ 'invalid': validation.dueDate }" @blur="bluredField('dueDate')" @focus="focusedField('dueDate')">
        <p>{{ validation.dueDate }}</p>
            <input type="hidden" data-checkout="cardExpirationMonth" :value="dueDate.substr(0,2)">
            <input type="hidden" data-checkout="cardExpirationYear" :value="dueDate.substr(3,2)">
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="creditCardCVV">CVV *</label>
            <input data-checkout="securityCode" id="creditCardCVV" class="form-input" v-model="cvv" type="tel" v-mask="'####'" placeholder="000" :class="{ 'invalid': validation.cvv }" @blur="bluredField('cvv')" @focus="focusedField('cvv')">
        <p>{{ validation.cvv }}</p>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="creditCardName">Nome do Titular *</label>
        <input data-checkout="cardholderName" id="creditCardName" class="form-input" v-model="holderName" type="text" :class="{ 'invalid': validation.holderName }" @blur="bluredField('holderName')" @focus="focusedField('holderName')">
        <p>{{ validation.holderName }}</p>
      </div>
      <div class="form-group">
        <label for="creditCardDocument">CPF do Titular *</label>
        <input id="creditCardDocument" class="form-input" v-model="holderDocument" type="tel" v-mask="'###.###.###-##'" placeholder="000.000.000-00" :class="{ 'invalid': validation.holderDocument }" @blur="bluredField('holderDocument')" @focus="focusedField('holderDocument')">
        <p>{{ validation.holderDocument }}</p>
        <input type="hidden" data-checkout="docType" value="CPF">
        <input type="hidden" data-checkout="docNumber" :value="holderDocument.replace(/[.-]/g, '')">
      </div>
      <div class="text-center form-group">
        <button class="button button-success mx-auto" @click="payWithCreditCard()">
          Confirmar pagamento no cartão
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
  name: 'creditCardForm',
  directives: {
    mask
  },
  props: ['maxInstallments', 'creditCardData', 'total', 'fees', 'pagseguroKey'],
  data () {
    return {
      installments: '',
      number: '',
      dueDate: '',
      cvv: '',
      holderName: '',
      holderDocument: '',
      paymentMethodId: null,
      token: null,
      firstDigits: null,
      lastDigits: null,
      tokenDueDate: null,
      focused: null,
      blured: {
        installments: false,
        number: false,
        dueDate: false,
        cvv: false,
        holderName: false,
        holderDocument: false
      },
      serverErros: {
        installments: [],
        number: [],
        dueDate: [],
        cvv: [],
        holderName: [],
        holderDocument: []
      },
      error: null
    }
  },
  computed: {
    creditCardMask () {
      return (this.paymentMethodId === 'amex') ? '#### ###### #####' : '#### #### #### ####'
    },
    validation () {
      let validation = { valid: true }

      if (this.blured.installments && this.installments === '') {
        validation.installments = 'Escolha a forma de pagamento.'
        validation.valid = false
      } else if (this.serverErros && this.serverErros.installments && this.serverErros.installments.length > 0) {
        validation.installments = this.serverErros.installments[0]
        validation.valid = false
      }

      if (this.focused !== 'number') {
        if (this.blured.number && this.number === '') {
          validation.number = 'Informe o número do cartão.'
          validation.valid = false
        } else if (this.blured.number && this.number !== '' && this.number.length < 17) {
          validation.number = 'Não é um cartão de crédito válido.'
          validation.valid = false
        } else if (this.serverErros && this.serverErros.number && this.serverErros.number.length > 0) {
          validation.number = this.serverErros.number[0]
          validation.valid = false
        }
      }

      if (this.focused !== 'dueDate') {
        if (this.blured.dueDate && this.dueDate === '') {
          validation.dueDate = 'Informe a validade.'
          validation.valid = false
        } else if (this.blured.dueDate && this.dueDate !== '' && (this.dueDate.length < 5 || !this.$moment(this.dueDate, 'MM/YY').isValid() || this.$moment(this.dueDate, 'MM/YY').isBefore(this.$moment()))) {
          validation.dueDate = 'Não é uma data válida.'
          validation.valid = false
        } else if (this.serverErros && this.serverErros.dueDate && this.serverErros.dueDate.length > 0) {
          validation.dueDate = this.serverErros.dueDate[0]
          validation.valid = false
        }
      }

      if (this.focused !== 'cvv') {
        if (this.blured.cvv && this.cvv === '') {
          validation.cvv = 'Informe o código de segurança.'
          validation.valid = false
        } else if (this.blured.cvv && this.cvv !== '' && this.cvv.length < 3) {
          validation.cvv = 'Não é um código de segurança válido.'
          validation.valid = false
        } else if (this.serverErros && this.serverErros.cvv && this.serverErros.cvv.length > 0) {
          validation.cvv = this.serverErros.cvv[0]
          validation.valid = false
        }
      }

      if (this.focused !== 'holderName') {
        if (this.blured.holderName && this.holderName === '') {
          validation.holderName = 'Informe o nome do titular.'
          validation.valid = false
        } else if (this.serverErros && this.serverErros.holderName && this.serverErros.holderName.length > 0) {
          validation.holderName = this.serverErros.holderName[0]
          validation.valid = false
        }
      }

      if (this.focused !== 'holderDocument') {
        if (this.blured.holderDocument && this.holderDocument === '') {
          validation.holderDocument = 'Informe o CPF do titular.'
          validation.valid = false
        } else if (this.blured.holderDocument && this.holderDocument !== '' && !this.documentValidation(this.holderDocument)) {
          validation.holderDocument = 'Não é um CPF válido.'
          validation.valid = false
        } else if (this.serverErros && this.serverErros.cpf && this.serverErros.holderDocument.length > 0) {
          validation.holderDocument = this.serverErros.holderDocument[0]
          validation.valid = false
        }
      }

      return validation
    }
  },
  watch: {
    // 'number' (val, oldVal) {
    //   if (val.length > 6 && (!this.paymentMethodId || val.replace(/[ ]/g, '').substring(0, 6) !== oldVal.replace(/[ ]/g, '').substring(0, 6))) {
    //     PagSeguro.getCardBrand({
    //       cardBin: val.replace(' ', '').substring(0, 6),
    //       success: (response) => {
    //         // Exemplo de retorno: { brand: { name: "visa" } }
    //         this.paymentMethodId = response.brand.name
    //       }
    //     })
    //   }
    // }
  },
  methods: {
    focusedField (field) {
      if (this.serverErros && this.serverErros[field] && this.serverErros[field].length > 0) {
        this.serverErros[field] = []
      }
      this.focused = field
      this.error = null
    },
    bluredField (field) {
      this.focused = null
      this.blured[field] = true
    },
    documentValidation (cpf) {
      let numCpf = cpf.replace(/[.-]/g, '')
      if (numCpf.length !== 11) {
        return false
      } else {
        if (numCpf[0] === numCpf[1] && numCpf[1] === numCpf[2] && numCpf[2] === numCpf[3] && numCpf[3] === numCpf[4] && numCpf[4] === numCpf[5] && numCpf[5] === numCpf[6] && numCpf[6] === numCpf[7] && numCpf[7] === numCpf[8] && numCpf[8] === numCpf[9] && numCpf[9] === numCpf[10]) {
          return false
        } else {
          let soma1 = numCpf[0] * 10 + numCpf[1] * 9 + numCpf[2] * 8 + numCpf[3] * 7 + numCpf[4] * 6 + numCpf[5] * 5 + numCpf[6] * 4 + numCpf[7] * 3 + numCpf[8] * 2
          let soma2 = numCpf[0] * 11 + numCpf[1] * 10 + numCpf[2] * 9 + numCpf[3] * 8 + numCpf[4] * 7 + numCpf[5] * 6 + numCpf[6] * 5 + numCpf[7] * 4 + numCpf[8] * 3 + numCpf[9] * 2

          let resultado1 = (soma1 * 10 % 11 > 9) ? 0 : soma1 * 10 % 11
          let resultado2 = (soma2 * 10 % 11 > 9) ? 0 : soma2 * 10 % 11

          if (resultado1 === parseInt(numCpf[9]) && resultado2 === parseInt(numCpf[10])) {
            return true
          } else {
            return false
          }
        }
      }
    },
    payWithCreditCard () {
      this.focused = null
      this.bluredField('installments')
      this.bluredField('number')
      this.bluredField('dueDate')
      this.bluredField('cvv')
      this.bluredField('holderName')
      this.bluredField('holderDocument')

      if (this.validation.valid) {
        this.$emit('sending')
        let vue = this

        // 1. Preparar o ano com 4 dígitos para o PagSeguro
        const yearRaw = vue.dueDate.substr(3, 2)
        const yearFull = yearRaw.length === 2 ? `20${yearRaw}` : yearRaw

        // 2. Criptografia (Exigência do PagBank)
        const encryption = window.PagSeguro.encryptCard({
          publicKey: vue.pagseguroKey, // Obtida previamente via n8n
          holder: vue.holderName,
          number: vue.number.replace(/\s/g, ''),
          expMonth: vue.dueDate.substr(0, 2),
          expYear: yearFull,
          securityCode: vue.cvv
        })

        if (encryption.errors && encryption.errors.length > 0) {
          console.error('Erro na criptografia:', encryption.errors)
          return
        }

        // 3. Seu objeto 'data' original com os novos campos adicionados
        let data = {
          // Seus campos originais para o Banco de Dados
          payment_method: 'credit_card',
          fee_id: vue.fees['creditCard' + vue.installments].id,
          credit_card: {
            payment_method_id: vue.paymentMethodId,
            token: encryption.encryptedCard, // Substituímos o token antigo pelo novo hash criptografado
            first_six_digits: vue.number.replace(/\s/g, '').substr(0, 6),
            expiration_month: vue.dueDate.substr(0, 2),
            expiration_year: yearFull, // Agora com 4 dígitos para ser compatível
            last_four_digits: vue.number.replace(/\s/g, '').substr(vue.number.length - 4, 4),
            identification_name: vue.holderName,
            identification_type: 'CPF',
            identification_number: vue.holderDocument.replaceAll('.', '').replace('-', ''),
            date_due: vue.dueDate
          },
          // Campo extra para facilitar o mapeamento no n8n sem quebrar o resto
          pagbank_encrypted: encryption.encryptedCard,
          installments: vue.installments
        }

        vue.$emit('pay-proceed', data)

        // var form = document.querySelector('#pay')
        // window.Mercadopago.createToken(form, (status, response) => {
        //   if (status === 200 || status === 201) {
        //     vue.token = response.id
        //     vue.firstDigits = response.first_six_digits
        //     vue.lastDigits = response.last_four_digits
        //     vue.tokenDueDate = response.date_due

        //     let data = {
        //       payment_method: 'credit_card',
        //       fee_id: vue.fees['creditCard' + vue.installments].id,
        //       credit_card: {
        //         payment_method_id: vue.paymentMethodId,
        //         token: vue.token,
        //         first_six_digits: vue.firstDigits,
        //         expiration_month: vue.dueDate.substr(0, 2),
        //         expiration_year: vue.dueDate.substr(3, 2),
        //         last_four_digits: vue.lastDigits,
        //         identification_name: vue.holderName,
        //         identification_type: 'CPF',
        //         identification_number: vue.holderDocument,
        //         date_due: vue.tokenDueDate
        //       }
        //     }

        //     vue.$emit('pay-proceed', data)
        //   } else if (response.cause) {
        //     for (let i = 0, l = response.cause.length; i < l; i++) {
        //       if (response.cause[0].code === 'E301') {
        //         vue.serverErros.number.push('Número do cartão é inválido.')
        //       } else if (response.cause[0].code === '325' || response.cause[0].code === '326') {
        //         vue.serverErros.dueDate.push('Verifique a validade.')
        //       } else if (response.cause[0].code === 'E302') {
        //         vue.serverErros.cvv.push('Código de segurança inválido.')
        //       } else if (response.cause[0].code === '306') {
        //         vue.serverErros.cvv.push('Nome do titular inválido.')
        //       }
        //     }

        //     vue.error = 'Verifique os campos em vermelho'
        //     vue.$emit('error')
        //   } else {
        //     vue.error = 'Houve um problema ao se conectar com o servidor, por favor tente novamente'
        //     vue.$emit('error')
        //   }
        // })
      } else {
        this.error = 'Verifique os campos em vermelho'
        this.$emit('error')
      }
    },
    loadSDK () {
      return new Promise((resolve, reject) => {
        // Se já existir, resolve imediatamente
        if (window.PagSeguro) {
          resolve(window.PagSeguro)
          return
        }

        const script = document.createElement('script')
        // Usando a URL sem o .min que costuma ser mais estável
        script.src = 'https://assets.pagseguro.com.br/checkout-sdk-js/rc/dist/browser/pagseguro.min.js'
        script.type = 'text/javascript'

        script.onload = () => {
          if (window.PagSeguro) {
            resolve(window.PagSeguro)
            console.log('aqui deu certo')
          } else {
            reject(new Error('Objeto PagSeguro não encontrado após carregar script'))
            console.log('aqui deu errado')
          }
        }

        script.onerror = () => {
          reject(new Error('Erro de rede ao carregar o SDK do PagSeguro'))
          console.log('aqui deu errado 2')
        }

        document.body.appendChild(script)
      })
    }
  },
  async mounted () {
    // Adicionar api do mercado pago
    this.loadSDK()
    // script.onload = function () {
    //   // Setar chave)
    //   window.Mercadopago.setPublishableKey(process.env.VUE_APP_MP_API_KEY)
    // }
  }
}
</script>
